<template>
  <div class="pub_footer">
    <div class="upper" :style="{backgroundColor:bColor}">
      <ul class="content container1">
        <li>
          <img src="@/assets/img/dbdh-1.png" alt="图片加载失败" />
          <p>
            <span class="fs_item">一站式</span>
            <span class="ls_item">家居服务</span>
          </p>
        </li>
        <li>
          <img src="@/assets/img/dbdh-2.png" alt="图片加载失败" />
          <p>
            <span class="fs_item">精挑细选</span>
            <span class="ls_item">专业选品</span>
          </p>
        </li>
        <li>
          <img src="@/assets/img/dbdh-3.png" alt="图片加载失败" />
          <p>
            <span class="fs_item">专业跟单</span>
            <span class="ls_item">团队服务</span>
          </p>
        </li>
        <li>
          <img src="@/assets/img/dbdh-4.png" alt="图片加载失败" />
          <p>
            <span class="fs_item">物流配送</span>
            <span class="ls_item">安装无忧</span>
          </p>
        </li>
      </ul>
    </div>

    <div class="Below">
      <div class="below_box container1" v-if="list.length>0">
        <div class="menu" v-for="(item,index) in list" :key="index">
          <h4>{{item.name}}</h4>
          <div class="submenu" v-for="(ele,num) in item.infoList" :key="num">
            <router-link target="_blank" :to="{path:'/helpWord',query:{id: ele.id}}">{{ele.title}}</router-link>
          </div>
        </div>
      </div>
      <div class="other_links">
        <p v-if="false">
          <a href="https://www.duobihouse.com" target="_blank" rel="noopener noreferrer">
            <span>关于我们</span>
          </a>
          <span> 丨 </span>
          <a href="https://www.duobihouse.com" target="_blank" rel="noopener noreferrer">
            <span>联系我们</span>
          </a>
          <span> 丨 </span>
          <a href="https://www.duobihouse.com" target="_blank" rel="noopener noreferrer">
            <span>加入我们</span>
          </a>
          <span> 丨 </span>
          <a href="https://www.duobihouse.com" target="_blank" rel="noopener noreferrer">
            <span>招募城市合伙人</span>
          </a>
          <span> 丨 </span>
          <a href="https://www.duobihouse.com" target="_blank" rel="noopener noreferrer">
            <span>媒体报道</span>
          </a>
        </p>
        <p class="icp">
          <span>Copyright ©2020-{{new Date().getFullYear()}} 多比duobihouse.com版权所有。ICP备案证书号：</span>
          <a href="http://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">
            <span>蜀ICP备20022182号-1</span>
          </a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { GetBotInfo } from "@/pages/page1/api/modules/home";
export default {
  props: {
    bColor: {
      type: String,
      default: "#ffffff",
    },
  },
  name: "publicFooter",
  data() {
    return {
      list: [],
    };
  },
  mounted() {
    this.getBotInfoList(this.$configId.defineId);
  },
  methods: {
    getBotInfoList(id) {
      let params = {
        defineId: id,
        categoryPositionId: "2c747e9ce05711eaacf200163e017b6f", //属于底部的分类
        categoryCount: "4",
        infoPositionId: "c66d1b18e05711eaacf200163e017b6f", //属于底部的内容
        infoCount: "6",
      };
      GetBotInfo(params).then((res) => {
        // console.log("底部信息", res);
        this.list = res.data;
      });
    },
  },
};
</script>

<style scoped lang="less">
.pub_footer {
  width: 100%;
  min-width: @themeWidth;
  color: #ffffff;
  .upper {
    height: 190px;
    .content {
      width: @themeWidth;
      height: 100%;
      padding: 30px 0 48px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-around;
      li {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        img {
          width: auto;
          height: auto;
        }
        .fs_item {
          font-size: 18px;
          font-weight: 800;
          color: #100c07;
          padding-right: 6px;
        }
        .ls_item {
          font-size: 16px;
          color: #43423f;
        }
      }
    }
  }
  .Below {
    background: #100c07;
    padding: 56px 0 60px;
    .below_box {
      display: flex;
      justify-content: space-around;
      margin-bottom: 90px;
      .menu {
        text-align: center;
        max-width: 238px;
        h4 {
          font-size: 18px;
          margin-bottom: 20px;
        }
        .submenu {
          margin-top: 10px;
          font-size: 14px;
          cursor: pointer;
          a {
            color: #fff;
          }
        }
      }
    }
    .other_links {
      text-align: center;
      font-size: 12px;
      font-weight: 500;
      color: #ffffff;
      a {
        color: #ffffff;
      }
      .icp {
        margin-top: 36px;
        color: #f1f1f1;
        a {
          color: #f1f1f1;
        }
      }
    }
  }
}
</style>
